import React, { useState, useEffect } from 'react';
import { useGeneralContext } from './GeneralContext.js';
import {
  Box,
  Collapse,
  HStack,
  VStack,
  useColorModeValue,
  Flex,
  IconButton,
  useBreakpointValue,
} from '@chakra-ui/react';
import { FiMenu, FiHome, FiMeh, FiUsers, FiBook } from 'react-icons/fi';
import { FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import CharacterNavItem from './CharacterNavItem.jsx';
import { STORAGE_KEYS, ROUTES } from '../constants.js';

const SideBar = () => {
  const { charIndex } = useGeneralContext();
  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleSideBar = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {}, [charIndex]);

  return (
    <Flex>
      <Box
        position="sticky"
        top="0"
        left="0"
        w={isMobile ? '60px' : '0px'}
        h="100vh"
      ></Box>
      <Box
        as="nav"
        position={{
          base: isMobile ? 'fixed' : 'sticky',
          sm: 'sticky',
        }}
        top="0"
        left="0"
        w={isCollapsed ? '60px' : '180px'}
        h="100vh"
        bg={useColorModeValue('gray.100', 'gray.900')}
        boxShadow="lg"
        zIndex={isMobile && !isCollapsed ? 1000 : 'auto'}
      >
        <VStack align="stretch" p="4" spacing="6">
          <IconButton
            aria-label="Toggle Sidebar"
            icon={<FiMenu />}
            onClick={toggleSideBar}
            alignSelf={isCollapsed ? 'center' : 'flex-end'}
          />
          <VStack align={isCollapsed ? 'center' : 'stretch'} spacing="4">
            <NavItem
              icon={FiHome}
              label="Home"
              to="/"
              isCollapsed={isCollapsed}
            />
            <NavItem
              icon={FiMeh}
              label="PlaceHolder"
              to="/placeholder"
              isCollapsed={isCollapsed}
            />
            <NavItem
              icon={FiBook}
              label="Rules"
              to="/rules"
              isCollapsed={isCollapsed}
            />
            {charIndex.map(index => (
              <CharacterNavItem
                key={index}
                icon={FaUser}
                name={index.split(STORAGE_KEYS.CHARACTER_PREFIX)[1]}
                to={index}
                isCollapsed={isCollapsed}
              />
            ))}
            <NavItem
              icon={FiUsers}
              label="New Character"
              to={ROUTES.CHARACTER}
              isCollapsed={isCollapsed}
            />
          </VStack>
        </VStack>
      </Box>
      {isMobile && !isCollapsed && (
        <Box
          position="fixed"
          top="0"
          left="0"
          w="100vw"
          h="100vh"
          bg="blackAlpha.600"
          zIndex={999}
          onClick={toggleSideBar}
        />
      )}
    </Flex>
  );
};

const NavItem = ({ icon, label, to, isCollapsed }) => (
  <HStack spacing="4">
    <Link to={to}>
      <Box as={icon} boxSize="25" />
    </Link>
    <Collapse in={!isCollapsed} animateOpacity>
      <Link to={to} style={{ textDecoration: 'none' }}>
        {label}
      </Link>
    </Collapse>
  </HStack>
);

export default SideBar;
